import "./AutocompleteAntd.css";

import { LoadingOutlined } from "@ant-design/icons";
import { IconButton } from "@material-ui/core";
import { ArrowDropDown, Close } from "@material-ui/icons";
import { Select, Spin } from "antd";
import { debounce } from "lodash";
import { useCallback } from "react";

const AutocompleteAntd = ({
  value,
  onChange,
  onInputChange,
  onScrollBottom,
  label,
  options,
  loading,
  ...otherProps
}) => {
  const handleSearch = useCallback(
    debounce((inputValue) => {
      onInputChange(inputValue);
    }, 300),
    []
  );

  const handleScrollToBottom = (e) => {
    const isBottom =
      Math.ceil(e.target.scrollTop) + e.target.clientHeight >=
      e.target.scrollHeight;
    if (isBottom) {
      onScrollBottom();
    }
  };

  const handleChangeOption = (newValue) => {
    onChange(newValue);
    if (!newValue) {
      onInputChange("");
    }
  };

  return (
    <div className="autocomplete__container">
      <label className="autocomplete__label">{label}</label>
      <Select
        allowClear
        className="autocomplete__select"
        popupClassName="autocomplete__dropdown"
        onChange={handleChangeOption}
        onPopupScroll={handleScrollToBottom}
        onSearch={handleSearch}
        showSearch
        getPopupContainer={(trigger) => trigger.parentNode}
        value={value || undefined}
        dropdownRender={(menu) => (
          <Spin
            spinning={loading}
            indicator={
              <LoadingOutlined
                style={{ fontSize: 30, color: "#fcb71e" }}
                spin
              />
            }>
            {menu}
          </Spin>
        )}
        suffixIcon={<ArrowDropDown />}
        filterOption={false}
        clearIcon={
          <IconButton className="autocomplete__button-clear">
            <Close />
          </IconButton>
        }
        loading={loading}
        style={{ width: "100%" }}
        size="large"
        notFoundContent="Không có dữ liệu"
        {...otherProps}>
        {options.map((item, key) => (
          <Select.Option value={item.value} key={key}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default AutocompleteAntd;
